function initWangsUIStore() {
    if (!window.WangsUI) {
        window.WangsUI = {
            presets: {
                'WANGS-TAB-MENU': {},
                'WANGS-INPUT-OTP': {},
            },
        };
    }
}
/**
 * Sets a preset configuration for a specific WangsUI web component.
 *
 * This function ensures type safety by enforcing that the value passed
 * matches the expected type for the given tag name, as defined in `WangsUIPresets`.
 *
 * @template K - The key of the component tag (e.g., 'WANGS-TAB-MENU') in `WangsUIPresets`.
 * @param {K} tagName - The UPPERCASE custom element tag name (e.g., 'WANGS-TAB-MENU').
 * @param {WangsUIPresets[K]} value - The configuration object for the given tag, must match the expected preset type.
 *
 * @example
 * setPreset('WANGS-TAB-MENU', {
 *   items: ['Home', 'Settings'],
 *   selectedIndex: 0,
 * });
 */
function setPreset(tagName, value) {
    initWangsUIStore();
    window.WangsUI.presets[tagName] = value;
}
/**
 * Retrieves a preset configuration for a specific WangsUI web component.
 *
 * @template K - The key of the component tag in `WangsUIPresets`.
 * @param tagName - The web component tag name (e.g., 'WANGS-TAB-MENU').
 * @returns The configuration object for the specified tag, or `undefined` if not set.
 *
 * @example
 * const preset = getPreset('WANGS-TAB-MENU');
 * console.log(preset?.items); // ['Home', 'Settings']
 */
function getPreset(tagName) {
    initWangsUIStore();
    return window.WangsUI.presets[tagName];
}
function usePreset(tag, override) {
    return { ...getPreset(tag), ...override };
}
/**
 * Tailwind class function helper to preserve literal types and enable IntelliSense.
 *
 * Ensures the preset structure matches the tag's expected type.
 *
 * @param tag - Component tag name (must be a key in WangsUIPresets)
 * @param preset - The preset object matching the type for the tag
 * @returns The same preset with literal types preserved.
 */
function definePreset(tag, preset) {
    return { [tag]: preset }[tag];
}

export { definePreset as d, getPreset as g, initWangsUIStore as i, setPreset as s, usePreset as u };
